import { top149Api } from '../../../services';
import {
	createStatsQueryHook,
	createChartQueryHook,
	type StatsQueryParams,
	type ChartQueryParams,
} from '../../../hooks';

const TOP149_FILTER_KEYS = ['query', 'years', 'maKhoa', 'maNganh', 'maTinh'] as const;

export interface UseTop149QueryParams extends StatsQueryParams {
	yearsAchieveTop149?: number;
	maTinhMoi?: string[];
	hasCodeNameChange?: boolean;
	/** true khi maTinh/maTinhMoi đến từ CÙNG một ô tìm kiếm tự do khớp cả hai
	 * không gian mã tỉnh — backend phải ghép OR thay vì AND. */
	provinceQueryOr?: boolean;
}

export interface UseTop149ChartParams extends ChartQueryParams {
	yearsAchieveTop149?: number;
}

/**
 * Factory-based Top149 stats hook with entity-specific extra params.
 */
const _useTop149StatsQuery = createStatsQueryHook({
	entityKey: 'top149',
	apiFn: (params) => top149Api.getTop149Stats(params),
	filterKeys: TOP149_FILTER_KEYS,
});

function toTop149StatsParams(params: UseTop149QueryParams): StatsQueryParams {
	const { yearsAchieveTop149, maTinhMoi, hasCodeNameChange, provinceQueryOr, ...baseParams } = params;

	const extraParams: Record<string, unknown> = {};
	if (yearsAchieveTop149 !== undefined) extraParams.yearsAchieveTop149 = yearsAchieveTop149;
	if (maTinhMoi && maTinhMoi.length > 0) extraParams.maTinhMoi = maTinhMoi;
	if (hasCodeNameChange !== undefined) extraParams.hasCodeNameChange = hasCodeNameChange;
	if (provinceQueryOr) extraParams.provinceQueryOr = provinceQueryOr;

	return {
		...baseParams,
		extraParams: Object.keys(extraParams).length > 0 ? extraParams : undefined,
	};
}

export function useTop149Query(params: UseTop149QueryParams) {
	return _useTop149StatsQuery(toTop149StatsParams(params));
}

export function buildTop149ExportParams(params: UseTop149QueryParams): URLSearchParams {
	return _useTop149StatsQuery.buildExportParams(toTop149StatsParams(params));
}

/**
 * Factory-based Top149 chart hook with yearsAchieveTop149 extra param.
 */
const _useTop149ChartQuery = createChartQueryHook({
	entityKey: 'top149',
	apiFn: (params) => top149Api.getNivoLineChartData(params),
	filterKeys: TOP149_FILTER_KEYS,
});

export function useTop149ChartQuery(params?: UseTop149ChartParams) {
	const extraParams: Record<string, unknown> = {};
	if (params?.yearsAchieveTop149 !== undefined) {
		extraParams.yearsAchieveTop149 = params.yearsAchieveTop149;
	}

	return _useTop149ChartQuery({
		filters: params?.filters,
		extraParams: Object.keys(extraParams).length > 0 ? extraParams : undefined,
	});
}


